import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import { prepareData } from 'helpers/prepare-req-data'
import { prepParams } from 'helpers/prep-req-url'
import { getRespData  } from 'helpers/get-resp-data'
import client from 'api'
import _ from 'lodash'

import { v4 as uuid4 } from 'uuid'


const initialState = {
    startProcessKxDiamantMLImmoBuExportStatus: 'idle',
    startProcessKxDiamantMLImmoBuExportError: undefined as any,
    loadUserParamsProcessKxDiamantMLImmoBuExportStatus: 'idle',
    loadUserParamsProcessKxDiamantMLImmoBuExportError: undefined as any,

    processKxDiamantMLImmoBuExportList: [] as any[],
    defaultValues: undefined as any,
    job: undefined as any,
    filterValues: {} as any,
    filterLookupValues: {} as any,

    directLoad: false,
    load: false,
    activeDivRef: null as any,

    filterValuesId: null,
    valuesFromDB: false,
    filterVisibleId: null,
    filterVisible: true,
}


export const startProcessKxDiamantMLImmoBuExport = createAsyncThunk('processKxDiamantMLImmoBuExportSlice/startProcessKxDiamantMLImmoBuExport', async ({ processKxDiamantMLImmoBuExport }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.post(
        `/api/ixweb/StartProcessKxDiamantMLImmoBuExport/`,
        prepareData(processKxDiamantMLImmoBuExport),
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { startProcessKxDiamantMLImmoBuExportStatus } = getState().processKxDiamantMLImmoBuExportSlice
        return startProcessKxDiamantMLImmoBuExportStatus !== 'pending'
    }
})

export const loadUserParamsProcessKxDiamantMLImmoBuExport = createAsyncThunk('processKxDiamantMLImmoBuExportSlice/loadUserParamsProcessKxDiamantMLImmoBuExport', async (_: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/LoadUserParamsProcessKxDiamantMLImmoBuExport/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadUserParamsProcessKxDiamantMLImmoBuExportStatus } = getState().processKxDiamantMLImmoBuExportSlice
        return loadUserParamsProcessKxDiamantMLImmoBuExportStatus !== 'pending'
    }
})

const ProcessKxDiamantMLImmoBuExportSlice = createSlice({
    name: 'processKxDiamantMLImmoBuExportSlice',
    initialState,
    reducers: {
        resetstartProcessKxDiamantMLImmoBuExport: (state) => {
            state.job = undefined
            state.startProcessKxDiamantMLImmoBuExportError = undefined
        },
        resetstartProcessKxDiamantMLImmoBuExportError: (state) => {
            state.startProcessKxDiamantMLImmoBuExportError = undefined
        },
        resetloadUserParamsProcessKxDiamantMLImmoBuExport: (state) => {
            state.defaultValues = undefined
            state.loadUserParamsProcessKxDiamantMLImmoBuExportError = undefined
        },
        resetloadUserParamsProcessKxDiamantMLImmoBuExportError: (state) => {
            state.loadUserParamsProcessKxDiamantMLImmoBuExportError = undefined
        },
        removeFromProcessKxDiamantMLImmoBuExportListById: (state, action) => {
            state.processKxDiamantMLImmoBuExportList = state.processKxDiamantMLImmoBuExportList.filter((x: any) => x.HDR_ID !== action.payload)
        },
        removeFromProcessKxDiamantMLImmoBuExportListByIds: (state, action) => {
            state.processKxDiamantMLImmoBuExportList = state.processKxDiamantMLImmoBuExportList.filter((x: any) => action.payload.indexOf(x.HDR_ID) === -1)
        },
        setFilterValues: (state, action) => {
            if (action.payload === undefined || action.payload === null) {
                state.filterValues = {}
            } else {
                state.filterValues = { ...state.filterValues, ...action.payload }
            }
        },
        setFilterLookupValue: (state, action) => {
            const { name, value, formValue } = action.payload
            if (name) {
                state.filterLookupValues[name] = value
                state.filterValues[name] = formValue
            }
        },
        setDirectLoad: (state, action) => { state.directLoad = action.payload },
        setLoad: (state, action) => { state.load = action.payload },
        setActiveDivRef: (state, action) => { state.activeDivRef = action.payload},
        setFilterValuesId: (state, action) => {
            state.filterValuesId = action.payload
        },
        setValuesFromDB: (state, action) => {
            state.valuesFromDB = action.payload
        },
        setFilterVisibleId: (state, action) => {
            state.filterVisibleId = action.payload
        },
        setFilterVisible: (state, action) => {
            state.filterVisible = action.payload
        },
        preloadData: (state, action) => {
            state.processKxDiamantMLImmoBuExportList = action.payload.map((x: any) => ({ ...x, HDR_ID: uuid4()}))
            state.startProcessKxDiamantMLImmoBuExportStatus = 'preloaded'
        },
        clearPreloadedData: (state) => {
            state.processKxDiamantMLImmoBuExportList = []
            state.startProcessKxDiamantMLImmoBuExportStatus = 'idle'
        },
    },
    extraReducers: builder => {
        builder.addCase(startProcessKxDiamantMLImmoBuExport.pending, (state) => {
            state.startProcessKxDiamantMLImmoBuExportStatus = 'pending'
            state.startProcessKxDiamantMLImmoBuExportError = undefined
        })
        builder.addCase(startProcessKxDiamantMLImmoBuExport.fulfilled, (state, action) => {
            state.startProcessKxDiamantMLImmoBuExportStatus = 'idle'

            {
                state.job = action.payload

            }
        })
        builder.addCase(startProcessKxDiamantMLImmoBuExport.rejected, (state, action) => {
            state.startProcessKxDiamantMLImmoBuExportStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.startProcessKxDiamantMLImmoBuExportError = action.error.message
            } else {
                state.startProcessKxDiamantMLImmoBuExportError = action.payload
            }
        })

        builder.addCase(loadUserParamsProcessKxDiamantMLImmoBuExport.pending, (state) => {
            state.loadUserParamsProcessKxDiamantMLImmoBuExportStatus = 'pending'
            state.loadUserParamsProcessKxDiamantMLImmoBuExportError = undefined
        })
        builder.addCase(loadUserParamsProcessKxDiamantMLImmoBuExport.fulfilled, (state, action) => {
            state.loadUserParamsProcessKxDiamantMLImmoBuExportStatus = 'idle'

            {
                state.defaultValues = action.payload

            }
        })
        builder.addCase(loadUserParamsProcessKxDiamantMLImmoBuExport.rejected, (state, action) => {
            state.loadUserParamsProcessKxDiamantMLImmoBuExportStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadUserParamsProcessKxDiamantMLImmoBuExportError = action.error.message
            } else {
                state.loadUserParamsProcessKxDiamantMLImmoBuExportError = action.payload
            }
        })

    }
})

export const {
    resetstartProcessKxDiamantMLImmoBuExport,
    resetstartProcessKxDiamantMLImmoBuExportError,
    resetloadUserParamsProcessKxDiamantMLImmoBuExport,
    resetloadUserParamsProcessKxDiamantMLImmoBuExportError,
    removeFromProcessKxDiamantMLImmoBuExportListById,
    removeFromProcessKxDiamantMLImmoBuExportListByIds,
    setFilterValues,
    setFilterLookupValue,
    setDirectLoad,
    setLoad,
    setActiveDivRef,
    setFilterValuesId,
    setValuesFromDB,
    setFilterVisible,
    setFilterVisibleId,
    preloadData,
    clearPreloadedData,
} = ProcessKxDiamantMLImmoBuExportSlice.actions
export default ProcessKxDiamantMLImmoBuExportSlice.reducer
